/** Display helpers for bus booking amounts including DPO M-Pesa KES/TZS. */

export function busMoneySymbol(currency) {
  const c = String(currency || '').toLowerCase();
  if (c === 'gbp') return '£';
  if (c === 'usd') return '$';
  if (c === 'eur') return '€';
  if (c === 'kes') return 'KES ';
  if (c === 'tzs') return 'TZS ';
  return '';
}

export function formatBusMoney(amount, currency) {
  const symbol = busMoneySymbol(currency);
  const value = Number(amount);
  if (!Number.isFinite(value)) return `${symbol}—`;
  if (String(currency).toLowerCase() === 'kes' || String(currency).toLowerCase() === 'tzs') {
    return `${symbol}${Math.round(value).toLocaleString()}`;
  }
  return `${symbol}${value.toFixed(2)}`;
}

export function isMobileMoneyProvider(paymentProvider) {
  const provider = String(paymentProvider || '').toLowerCase();
  return provider === 'dpo' || provider === 'pesapal';
}

export function displayBusBookingAmount(booking) {
  if (isMobileMoneyProvider(booking?.paymentProvider) && booking?.mobileMoneyAmount != null && booking?.mobileMoneyCurrency) {
    return formatBusMoney(booking.mobileMoneyAmount, booking.mobileMoneyCurrency);
  }
  return formatBusMoney(booking?.amount, booking?.currency);
}
